// src/hooks/useAvailableSports.js
import { useQuery } from '@tanstack/react-query';
import api from '../api';

async function fetchAvailableSports({ signal, category }) {
  const params = category && category !== 'all' ? { market_category: category } : undefined;
  const res = await api.get('available-sports/', { signal, timeout: 30_000, params });
  const sports = Array.isArray(res.data?.sports) ? res.data.sports : [];
  return sports.map(s => (typeof s === 'string' ? s : s?.key)).filter(Boolean);
}

// Shared, cached fetch of raw sport keys from /available-sports/. React Query
// dedupes/caches this across every consumer (Home, Value Finder, Parlay
// Picker, NFL, ...) so it's fetched once and shared regardless of mount order.
// `category` (market_category filter) is optional — Parlay Picker is the only
// consumer that scopes this by category; other pages call it with no args.
export function useAvailableSports(category) {
  const { data, isLoading } = useQuery({
    queryKey: ['available-sports', category ?? 'all'],
    queryFn: ({ signal }) => fetchAvailableSports({ signal, category }),
    staleTime: 5 * 60 * 1000,
  });
  return { sportKeys: data ?? [], loading: isLoading };
}
